var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('FullCalendar',{attrs:{"defaultView":"dayGridWeek","height":"auto","showNonCurrentDates":false,"plugins":_vm.calendarPlugins,"header":{
          left: 'dayGridWeek,dayGridMonth',
          center: 'title',
          right: 'today prev,next'
        },"buttonText":{
          'today': 'Today',
          'week': 'Week',
          'month': 'Month'
        },"events":_vm.calendar_events},on:{"eventClick":_vm.eventClick,"dateClick":_vm.dateClick}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }